const EVENT_ENDPOINT = '/api/events';

function safeText(value, maxLength = 240) {
  return String(value || '').replace(/\s+/g, ' ').trim().slice(0, maxLength);
}

function sendArticlePageview(article) {
  if (!article || window.__wlaArticlePageviewSent) return;
  window.__wlaArticlePageviewSent = true;

  const canonicalUrl = article.dataset.wlaPostUrl || window.location.href;
  const payload = {
    eventName: 'article_pageview',
    experimentKey: 'article-pageviews',
    variantKey: 'all',
    surface: 'article',
    placement: 'post',
    pagePath: `${window.location.pathname}${window.location.search}`,
    pageUrl: canonicalUrl,
    value: 1,
    meta: {
      postId: safeText(article.dataset.wlaPostId, 80),
      title: safeText(article.dataset.wlaPostTitle),
      slug: safeText(article.dataset.wlaPostSlug, 160),
      canonicalUrl: safeText(canonicalUrl, 240),
      referrer: safeText(document.referrer, 240)
    }
  };

  if (typeof window.gtag === 'function') {
    window.gtag('event', 'wla_article_pageview', {
      post_id: payload.meta.postId,
      post_slug: payload.meta.slug,
      page_location: canonicalUrl
    });
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'wla_article_pageview',
    post_id: payload.meta.postId,
    post_slug: payload.meta.slug,
    page_location: canonicalUrl
  });

  try {
    const body = JSON.stringify(payload);
    if (navigator.sendBeacon) {
      navigator.sendBeacon(EVENT_ENDPOINT, new Blob([body], { type: 'application/json' }));
      return;
    }
    fetch(EVENT_ENDPOINT, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body,
      keepalive: true
    }).catch(() => {});
  } catch {}
}

export function initArticlePageviewTracking() {
  sendArticlePageview(document.querySelector('[data-wla-article-pageview="1"]'));
}
